// extracted by mini-css-extract-plugin
export var discard = "_3m-3";
export var muiTooltipTooltip = "_3m-5";
export var notificationBar = "_3m-2";
export var saveButtonHoverSlotWrapper = "_3m-4";
export var show = "_3m-1";
export var spacer = "_3m-0";